import React from 'react';
import { connect } from 'react-redux';
import Logger, { LOG_LEVELS, ALL_MESSAGES } from '../../../utils/logger';
import ListingTypeSelector from '../Generic/ListingTypeSelector';
import LanguageStringResolver from '../../fields/language/LanguageStringResolver';
import ApplicationMessages from '../../inAppMessages/ApplicationMessages';
import HighlightOnInAppMessage from '../../inAppMessages/HighlightOninAppMessage';
import _ from 'lodash';
import { withFullStoryExclude } from '../../../utils/fullStoryHelper';

let FORM_NAME = 'ADD_LISTING_LINES';
let log = new Logger('ADD_LISTING_LINES', LOG_LEVELS.DEBUG);
const AMOUNT_REGEX = /^-?\d*[\.]?\d+$/;

class AddListingLines extends React.Component {

    constructor(props) {
        super(props);
        this.state = { 
            selectedListingType: '',
            vatNumber: '',
            totalAmount: 0
         }; 
        this.FORM_NAME_FOR_USER = _.uniqueId('addListingLinesForm_');      
        this.onAdd = this.onAdd.bind(this);
        this.onListingTypeChange = this.onListingTypeChange.bind(this);
        this.onVatNumberChange = this.onVatNumberChange.bind(this);
        this.onAmountChange = this.onAmountChange.bind(this);
        log = new Logger(this.FORM_NAME_FOR_USER, LOG_LEVELS.DEBUG);
    }

    onAdd(evt) {        
        let isInvalidForm = false;
        //Perform validations
        const vatNumber = this.state.vatNumber;
        if (!vatNumber || vatNumber.trim() === '') {
            log.setDictionaryMessage(ALL_MESSAGES.BLANK_VAT_NUMBER);
            isInvalidForm = true;
        }

        if(this.state.selectedListingType === '') {
            log.setDictionaryMessage(ALL_MESSAGES.BLANK_EC_TYPE);
            isInvalidForm = true;
        }

        //Perform validations
        let totalAmount = this.state.totalAmount || '';
        if(!AMOUNT_REGEX.test(totalAmount)){
            log.setDictionaryMessage(ALL_MESSAGES.INVALID_AMOUNT);
            isInvalidForm = true;
        }
        if (!isInvalidForm) {
            const newLine = {
                vatNumber: vatNumber,
                totalAmount: parseFloat(totalAmount === '' ? 0.0 : totalAmount).toFixed(2),
                ectype: this.state.selectedListingType,
                ecTypes:[...this.props.ecTypes],
            };
            this.setState({
                selectedListingType: '',
                vatNumber: '',
                totalAmount: ''
            });
            if(typeof this.props.onAdd === 'function') {
                this.props.onAdd(newLine);
            }
        }
    }

    onListingTypeChange(ectype) {
        this.setState({
            selectedListingType: ectype
        });
    }

    onVatNumberChange(event) {
        const newValue = event.target.value; 
        if(newValue !== this.state.vatNumber) {
            this.setState({
                vatNumber: newValue
            });
        }
    }

    onAmountChange(event) {
        const newValue = event.target.value; 
        if(newValue !== this.state.totalAmount) {
            this.setState({
                totalAmount: newValue
            });
        }
    }

    render() {        
        return (
            <div>
                <h2 className="mt20">{this.props.title}</h2>
                <s-row>
                    <s-col span="6">
                        <s-box name="form-panel" class="mb15">
                            <fieldset>
                                <ApplicationMessages scopes={[this.FORM_NAME_FOR_USER]} messageType="applicationError"/>
                                <label className="mt0"><LanguageStringResolver string='addListingLines_VATNumber'/></label>
                                <HighlightOnInAppMessage
                                    scopes={[this.FORM_NAME_FOR_USER]}
                                    messageIds={[ALL_MESSAGES.BLANK_VAT_NUMBER]} >
                                        <input id="vatNumber" value={this.state.vatNumber} onChange={this.onVatNumberChange}
                                />
                                </HighlightOnInAppMessage>
                                <label className="mt10"><LanguageStringResolver string='addListingLines_TotalAmount'/></label>
                                <HighlightOnInAppMessage
                                    scopes={[this.FORM_NAME_FOR_USER]}
                                    messageIds={[ALL_MESSAGES.INVALID_AMOUNT]} >
                                    <input className={withFullStoryExclude()} id="totalAmount" value={this.state.totalAmount} onChange={this.onAmountChange} />
                                </HighlightOnInAppMessage> 
                                    <label className="mt10">EC Type</label>
                                <HighlightOnInAppMessage
                                    scopes={[this.FORM_NAME_FOR_USER]}
                                    messageIds={[ALL_MESSAGES.BLANK_EC_TYPE]} >
                                    <ListingTypeSelector id="ecType" onChange={this.onListingTypeChange} value={this.state.selectedListingType} options={this.props.ecTypes} />
                                </HighlightOnInAppMessage>    
                                <button className="secondary mt20"
                                    onClick={this.onAdd}>
                                    <LanguageStringResolver string='addListingLines_AddNewECListingLine'/>
                                </button>
                            </fieldset>
                        </s-box>
                    </s-col>
                </s-row>
            </div>
        );
    }
}

function mapStateToProps(state, props) {
    log.debug('mapStateToProps: ', state);
    //const formNameForUser = FORM_NAME + '_FOR_' + (props.user !== undefined ? props.user.email : 'LoggedOut');
    return {
        languages: state.languages
        //FORM_NAME_FOR_USER: formNameForUser
    };
}

function mapDispatchersToProps(dispatch) {
    return {
    }
}


AddListingLines.defaultProps = {
    onAdd: () => { },
    ecTypes: [],
    title: ''
}

export default connect(mapStateToProps, mapDispatchersToProps)(AddListingLines);
